import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ExternalLinkArrow } from 'assets/ExternalLinkArrow.svg';
import MobileScrollableContent from './shared/MobileScrollableContent';
import { MobileSpacing } from './shared/MobileResponsiveSpacing';
import { MOBILE_SETTINGS_STYLES } from './shared/MobileSettingsStyles';
import { useMobileSettingsNavigation } from './shared/hooks/useMobileSettingsNavigation';
import MobilePageContent from 'app/pages/mobile/mobile-layout/MobilePageContent';
import { BACKGROUND_SIZES_v2 } from 'app/pages/mobile/utils/constants';

/**
 * MobileTermsConditionsPage - Terms & Conditions page for mobile app
 * Has header with back button but no footer navigation
 */
function MobileTermsConditionsPage(): JSX.Element {
  const { t } = useTranslation();
  const { handleBackSettings } = useMobileSettingsNavigation();

  return (
    <MobilePageContent
      transparentHeight={BACKGROUND_SIZES_v2.SHOW_HEADER}
      title={t('mobileTermsConditionsTitle')}
      onBack={handleBackSettings}
    >
      {/* Content Section */}
      <Box
        sx={{
          height: MobileSpacing.contentHeight, // Same as menu page
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden', // Prevent content from overlapping
          flex: 1, // Take available flex space
          minHeight: 0, // Allow shrinking for proper scroll behavior
        }}
      >
        {/* Scrollable Content */}
        <Box>
          <MobileScrollableContent>
            {/* Accepting The Terms Section */}
            <Box
              sx={{
                mb: MobileSpacing.marginBottomLarge,
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mb: MobileSpacing.marginBottomMedium,
                }}
              >
                {t('mobileTermsConditionsAcceptingTheTerms')}
              </Typography>
              <Typography variant="large" sx={MOBILE_SETTINGS_STYLES.descriptionText}>
                {t('mobileTermsConditionsAcceptingTheTermsDescription')}
              </Typography>
              <Box
                component="a"
                href="https://www.app.speedchain.com/platform_agreement_2.0.pdf"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  ...MOBILE_SETTINGS_STYLES.externalLink,
                  textDecoration: 'none',
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8,
                  },
                }}
              >
                <Typography variant="large" sx={MOBILE_SETTINGS_STYLES.externalLinkText}>
                  {t('mobileTermsConditionsReadFullAgreement')}
                </Typography>
                <ExternalLinkArrow style={MOBILE_SETTINGS_STYLES.externalLinkIcon} />
              </Box>
            </Box>
          </MobileScrollableContent>
        </Box>
      </Box>
    </MobilePageContent>
  );
}

export default MobileTermsConditionsPage;
